import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import {
  ICountry,
  IState,
  LocationCategory,
  Replacement,
} from '../../../interface';
import actions from '../../../redux/actions';
import style from './index.module.scss';
import localesReplacement from '../../../utils/localesReplacement';
import { LOCATIONCATEGORIES } from '../../../constants';
import { useSearchParams } from 'react-router-dom';

const cx = classnames.bind(style);

interface IProps {
  locationCategories?: string[];
  replacements: Replacement;
  setLocationCategories: (value: string[]) => void;
  setLocationType: (value: string[]) => void;
  locationCategoriesList: LocationCategory[] | null;
  country: ICountry;
  hasCastrolCertifiedWorkshops: boolean;
}

//location type component with redux
export const SubFilterSection = (props: IProps) => {
  const {
    locationCategories,
    replacements,
    setLocationCategories,
    setLocationType,
    locationCategoriesList,
    country,
    hasCastrolCertifiedWorkshops,
  } = props;
  const [types, setTypes] = useState<LocationCategory[]>([]);
  useEffect(() => {
    setTypes(locationCategoriesList ? locationCategoriesList : []);
  }, [locationCategoriesList, country]);


  const [searchParams] = useSearchParams();

  useEffect(() => {
    const tags = searchParams.get('locationCategories');
    if (tags) {
      const category = tags.split(",")
      setLocationCategories(category);
    }
  }, [searchParams])

  const certifiedButtonClick = () => {
    locationCategories?.some((x) => x === '0')
      ? //eslint-disable-next-line
        setLocationCategories([...locationCategories].slice(1))
      : //eslint-disable-next-line
        setLocationCategories(['0', ...(locationCategories || [])]);
  };

  return (
    <div className={cx('sub-filter-section')}>
      <ul>
        <li>
          <span
            className={`button ${cx({
              actived: _.isEqual(locationCategories, []),
            })}`}
            onClick={() => setLocationCategories([])}
          >
            {localesReplacement(replacements, 'All')}
          </span>
        </li>
        {_.map(types, (type, index) => (
          <li key={index}>
            <span
              className={`button ${cx({
                actived: _.includes(locationCategories, _.toString(type['id'])),
              })}`}
              role='button'
              onClick={() => {
                setLocationCategories(
                  _.includes(locationCategories, _.toString(type['id']))
                    ? _.without(locationCategories, _.toString(type['id']))
                    : _.chain(locationCategories)
                      .concat(_.toString(type['id']))
                      .uniq()
                      .value(),
                );
                setLocationType([]);
              }}
            >
              {localesReplacement(replacements, type['name'])}
            </span>
          </li>
        ))}
        {hasCastrolCertifiedWorkshops && (
          !_.includes(LOCATIONCATEGORIES, 'Castrol Service Certified') ? (
            <li>
              <span
                className={`button ${cx({
                  actived: locationCategories?.some((x) => x === '0'),
                })}`}
                onClick={certifiedButtonClick}
              >
                {localesReplacement(
                  replacements,
                  'Castrol Certified Workshops',
                )}
              </span>
            </li>
          ) : (
            <li>
              <span
                className={`button ${cx({
                  actived: locationCategories?.some((x) => x === '0'),
                })}`}
                onClick={certifiedButtonClick}
              >
                {localesReplacement(replacements, 'Castrol Service Certified')}
              </span>
            </li>
          )
        )}
      </ul>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  locationCategories: state.filter.locationCategories,
  replacements: state.replacements,
  locationCategoriesList: state.locationCategoriesList,
  country: state.country,
  hasCastrolCertifiedWorkshops: state.hasCastrolCertifiedWorkshops,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setLocationCategories: (value: string[]) =>
    dispatch(actions.setLocationCategories(value)),
  setLocationType: (locationType: string[]) =>
    dispatch(actions.setLocationType(locationType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubFilterSection);
